import { render, staticRenderFns } from "./EventAlarmTagsButtonAndTooltip.vue?vue&type=template&id=3b768699"
import script from "./EventAlarmTagsButtonAndTooltip.vue?vue&type=script&lang=ts"
export * from "./EventAlarmTagsButtonAndTooltip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports